/* eslint-disable */
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import authActions from '../../../redux/features/auth/actions';
import useAuthorizedEpApps from '../../../hooks/useAuthorizedEpApps';
import config from '../../../config/config';
import { PERFORMANCE_INSIGHTS_APP_NAME } from '../../../constants';
import { usePopupManager } from '../../../providers/PopupManager/PopupManager';
import LegalMainDashboard from '../../../components/LegalPageComp/MainDashboard/MainDashboard';
import styles from './RecordToReportPage.module.css';
import RecordToReportMainDashboard from '../../../components/RecordToReportComp/MainDashboard/MainDashboard';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import GLReconcilationDrilldown from '../../../components/RecordToReportComp/TMLPages/GLReconciliation';
import BankReconcilationDrilldown from '../../../components/RecordToReportComp/TMLPages/BankReconciliation';
import InterCompanyReconcilationDrilldown from '../../../components/RecordToReportComp/TMLPages/Intercompany';

const RecordToReportTMLChildPage = ({
  isAuthenticated,
  authPolicies,
  currentUserId,
}) => {

  // debugger
  const history = useHistory()

  console.log(history)

  const authorizedApps = useAuthorizedEpApps(isAuthenticated, authPolicies);
  const { showLoading } = usePopupManager();

  useEffect(() => {
    if (
      authorizedApps.length &&
      !authorizedApps.includes(PERFORMANCE_INSIGHTS_APP_NAME)
    ) {
      showLoading();
      window.location.replace(config.HOME_UI_BASE_URL);
    }
  }, [authorizedApps, currentUserId]);


  const ChildScreen = () => {
    // debugger
    let path = history.location.pathname?.split("/")

    if (path.includes("GL-Reconciliation")) {
      return <GLReconcilationDrilldown />
    }
    else if (path.includes("Bank-Reconcilation")) {
      return <BankReconcilationDrilldown />
    }
    else if (path.includes("InterCompany-Reconciliation")) {
      return <InterCompanyReconcilationDrilldown />
    }

  }


  return (
    <div className={styles.container}>
      <ChildScreen/>
    </div>
  )
}

RecordToReportTMLChildPage.propTypes = {
  isAuthenticated: PropTypes.bool.isRequired,
  authPolicies: PropTypes.object.isRequired,
  currentUserId: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
    .isRequired,
};

export default connect(({ auth, userProfile }) => ({
  isAuthenticated: auth.isAuthenticated,
  authPolicies: auth.authPolicies,
  currentUserId: userProfile.userId,
  setAuthToken: authActions.setAuthToken,
}))(RecordToReportTMLChildPage);
